/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { InlineEditDropdown } from "~/components/InlineEdit/InlineEditDropdown";
import { ServiceSubmitValues } from "~/components/Services/types";
import { Loading } from "~/components/Utils/Loading";
import { useAPIData } from "~/hooks/useAPIData";
import { ServiceCommitment } from "~/models";
import { displayLevel } from "~/tools";
import { Level } from "~/views/globalSettings/types";

type Props = {
  service: ServiceCommitment;
  onSubmit: (values: ServiceSubmitValues) => Promise<void>;
  canEdit: boolean;
};

function ServiceLevelSelector({ service, onSubmit, canEdit }: Props) {
  const [serviceLevels, serviceLevelsLoading] = useAPIData<Level[]>(
    "/servicelevels",
    (data) => data.serviceLevels,
    []
  );

  const options = serviceLevels.map((el) => ({
    value: el.id,
    label: el.name,
  }));

  if (serviceLevelsLoading) {
    return <Loading />;
  }

  return (
    <InlineEditDropdown
      name="serviceLevel"
      defaultValue={service.serviceLevel?.id || ""}
      display={displayLevel(service?.serviceLevel?.name)}
      options={options}
      onSubmit={(val) => onSubmit({ ...service, serviceLevelId: val })}
      canEdit={canEdit}
      width="80%"
    />
  );
}

export { ServiceLevelSelector };
